import { AppLayout } from '../AppLayout/AppLayout';
import { LegacyAppLayout } from '../LegacyAppLayout/LegacyAppLayout';
import { isNewAppLayoutEnabled } from 'config/environment';

export const ActiveAppLayout = (): JSX.Element => (isNewAppLayoutEnabled() ? <AppLayout /> : <LegacyAppLayout />);
